// Shared date helpers for Check tab visuals.

export const parseMonthDayFromDateString = (value) => {
  if (!value || typeof value !== "string") return null;
  const raw = value.trim();

  // YYYY-MM-DD (optionally followed by time)
  let m = raw.match(/^(\d{4})-(\d{1,2})-(\d{1,2})/);
  if (m) {
    const monthNum = Number(m[2]);
    const dayNum = Number(m[3]);
    if (Number.isFinite(monthNum) && Number.isFinite(dayNum)) {
      return { monthNum, dayNum };
    }
  }

  // MM/DD/YYYY or M/D/YYYY (optionally followed by time)
  m = raw.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})/);
  if (m) {
    const monthNum = Number(m[1]);
    const dayNum = Number(m[2]);
    if (Number.isFinite(monthNum) && Number.isFinite(dayNum)) {
      return { monthNum, dayNum };
    }
  }

  // Fallback for unusual but parseable date strings.
  const parsed = new Date(raw);
  if (Number.isNaN(parsed.getTime())) return null;
  return {
    monthNum: parsed.getMonth() + 1,
    dayNum: parsed.getDate(),
  };
};

export const isClearedBefore15th = (dateString) => {
  const parts = parseMonthDayFromDateString(dateString);
  if (!parts) return false;
  return parts.dayNum < 15;
};
